import { Container } from 'components/container'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Section = styled.div`
  margin-block: 5rem;

  ${mq.large} {
    margin-block: 6rem;
  }

  ${mq.ltLarge} {
    > ${Container} {
      padding-inline: 0;
    }
  }
`

export const Title = styled.h2`
  text-align: center;
  margin-top: 0;
  font-size: 2.8rem;
  font-weight: 700;

  ${mq.medium} {
    font-size: 3.4rem;
  }

  ${mq.large} {
    font-size: 4.8rem;
  }
`

export const Slide = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: end;
  width: calc(100vw - 5rem);
  padding: 4rem;
  aspect-ratio: 450 / 550;
  text-align: center;
  color: white;
  background: linear-gradient(
    to bottom,
    ${theme.colors.accent.secondaryLight},
    ${theme.colors.accent.secondary}
  );
  z-index: 0;

  ${mq.medium} {
    width: 45rem;
  }

  &::before {
    content: '';
    position: absolute;
    display: block;
    inset: 0;
    opacity: 0.9;
    mask: linear-gradient(to top, black, transparent) 50% 100% / 100% 2000%
      no-repeat;
    transition: all 5s;
    background: linear-gradient(
      to bottom,
      ${theme.colors.accent.secondaryLight},
      ${theme.colors.accent.secondary}
    );
  }

  .swiper-slide-active &::before {
    mask-size: 100% 50%;
    transition: all 0.6s ${theme.ease.out};
  }
`

export const SlideName = styled.h3`
  position: relative;
  margin: 0.5em 0;
  font-size: 3rem;
  font-weight: bold;
  line-height: 1.2;

  ${mq.medium} {
    font-size: 3.7rem;
  }
`

export const Image = styled.img`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
`

export const ReleaseDate = styled.p`
  position: relative;
`
